<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="store_popup_box purchase modal_cont" id="store_modal">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
        <img src="static/images/store/photo-confirm.png" class="purchase_img">
        <h2>{{ getBundleData.numberOfCoins ? getBundleData.numberOfCoins + ' ' + getTranslations.home_modals_confirm_purchase_games:'' }}
          {{getBundleData.numberOfCoins && getBundleData.points?getTranslations.home_modals_confirm_purchase_successfull_and :''}}
          {{ getBundleData.points ? getBundleData.points + ' ' + getTranslations.home_store_points : '' }}
          - {{ getBundleData.price}} {{ getBundleData.currencyCode }}</h2>
        <p>{{ getTranslations.home_modals_confirm_purchase_playing_more }}</p>
        <button type="" @click.prevent="purchaseBundle()">
          {{ getTranslations.home_modals_confirm_purchase_purchase_now_button }}
        </button>
        <a v-if="integrationCheck()" style="cursor: pointer" @click="$emit('close')" class="exit_link"> {{ getTranslations.project_config_visitor_register_2_exit }} </a>

      </div>
    </div>
  </div>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import modals from '@/common/modals';
import FailedPurchase from './FailedPurchase';
import ConfirmPurchaseSuccessful from './ConfirmPurchaseSuccessful';
import FailedPurchaseOperator from './FailedPurchaseOperator';

export default {
  name: 'confirmPurchase',
  data() {
    return {
      buttonEnabled: true,
    };
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'chargePinCall',
    ]),
    showModal() {
      modals.showHideModalInStore(this);
    },
    purchaseBundle() {
      this.buttonEnabled = false;
      this.getUserLoginDetails().then(() => {
        const bundleInfo = {
          bundleId: this.bundleId,
          pin: null,
        };
        this.chargePinCall({ value: bundleInfo }).then(() => {
          this.buttonEnabled = true;
          // eslint-disable-next-line
          console.log("----------------------- Correct ConfirmPurchase For  Store showHideModal" + this.chargePinResponse);
          if (this.chargePinResponse === 'OPERATION_SUCCESS') {
            this.$emit('bundlePurchase');
            this.storeModalForStore(ConfirmPurchaseSuccessful);
          } else if (this.chargePinResponse === 'BILLING_FAILED') {
            this.storeModalForStore(FailedPurchaseOperator);
          } else if (this.chargePinResponse === 'NO_BALANCE') {
            this.storeModalForStore(FailedPurchase);
          } else {
            this.storeModalForStore(FailedPurchaseOperator);
          }
          this.showModal();
        });
      });
    },
    integrationCheck() {
      return this.integrationHeader === this.availableIntegrations.DU_ETISALAT.name;
    },
  },
  computed: {
    ...mapState('profile', [
      'chargePinResponse',
      'bundleId',
    ]),
    ...mapState('common', [
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/ConfirmPurchase.vue